import request from '@/utils/request'

// 获取列表
export function getPointConfigList(data) {
  return request({
    url: '/admin/activity/webPonitConfig/list',
    method: 'post',
    data
  })
}

// 添加
export function addPointConfig(data) {
  return request({
    url: '/admin/activity/webPonitConfig/add',
    method: 'post',
    data
  })
}

// 修改
export function updatePointConfig(data) {
  return request({
    url: '/admin/activity/webPonitConfig/edit',
    method: 'post',
    data
  })
}

// 删除
export function removePointConfig(data) {
  return request({
    url: '/admin/activity/webPonitConfig/remove',
    method: 'post',
    data
  })
}
